// Class: motion._Actuate.EffectsOptions

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function motion_Actuate() {return require("./../../motion/Actuate");}
function motion_actuators_FilterActuator() {return require("./../../motion/actuators/FilterActuator");}

// Constructor

var EffectsOptions = function(target,duration,overwrite) {
	this.target = target;
	this.duration = duration;
	this.overwrite = overwrite;
}

// Meta

EffectsOptions.__name__ = ["motion","_Actuate","EffectsOptions"];
EffectsOptions.__isInterface__ = false;
EffectsOptions.prototype = {
	filter: function(reference,properties) {
		properties.filter = reference;
		return (motion_Actuate().default).tween(this.target,this.duration,properties,this.overwrite,(motion_actuators_FilterActuator().default));
	}
};
EffectsOptions.prototype.__class__ = EffectsOptions.prototype.constructor = $hxClasses["motion._Actuate.EffectsOptions"] = EffectsOptions;

// Init



// Statics




// Export

exports.default = EffectsOptions;